export class StorageKeys {

	static username = 'username';

	static config = 'config_v2';

	static businessId = 'moniepointAgentId';

	static businessName = 'businessName';

	static kycRegisteredBusinessDocumentStatus = 'kycRegisteredBusinessDocumentStatus';

	static moniepointAgentId = 'moniepointAgentId';

	static Business_Type_Display_Name = 'Business_Type_Display_Name';

	static business_form_questionnaire = 'business_form_questionnaire';

	static associated_business_types = "associated_business_types";

	static customer_business_type = "customer_business_type";

	static store_front_image_reference = "store_front_image_reference";

	static new_sign_up_data = 'new_sign_up_data';

	static is_deep_link = 'is_deep_link';

	static notification_payload = 'notification_payload';

	static firstName = 'firstName';

	static business_creation_response = 'business_creation_response';

	static isKycEditMode = 'isKycEditMode';

	static validation_key_v2 = 'validation_key_v2';

	static business_name_current_view = 'business_name_current_view';

	static business_name_previous_key = 'business_name_previous_key';

	static business_name_selected_detail = 'business_name_selected_detail';

	static is_business_name_selected = 'is_business_name_selected';

	static login_domains = 'login_domains';

	static SHOULD_COMPLETE_SELF_ONBOARDING_KYC = 'SHOULD_COMPLETE_SELF_ONBOARDING_KYC';

	static alert_modal_route = 'alert_modal_route';

	static modal_message = 'modal_message';

	static modal_lvl = 'modal_lvl';

	static modal_callbackName = 'modal_callbackName';

	static modal_title = 'modal_title';

	static level_one_progress = 'level_one_progress';

	static otp_suspension_time = 'otp_suspension_time';

	static id_suspension_time = 'id_suspension_time';

	static scope = 'scope';

	static clientId = 'client_id';

	static userType = 'userType';

	static deviceStatus = 'deviceStatus';

	static authenticationDomain = 'authenticationDomain';

	static panicMode = 'panicMode';

	static token = 'access_token';

	static fullname = 'name';

	static branch = 'branch';

	static jti = 'jti';

	static roles = 'roles';

	static userTypeInfo = 'userTypeInfo';

	static lastName = 'lastName';

	static email = 'email';

	static authorities = 'authorities';

	static uniqueIdentifier = 'device_identifier';

	static unique_device_identifier = 'unique_device_identifier';

	static encrypted_unique_device_identifier = 'encrypted_unique_device_identifier';

	static browser = 'browser';

	static exp = 'exp';

	static 'session_expiration' = 'session_expiration';

	static 'expires_in' = 'expires_in';

	static 'machine_os' = 'machine_os';

	static 'selected_role' = 'selected_role';

	static 'has_accessed_dashboard' = 'has_accessed_dashboard';

	static 'saved_bvn_data' = 'saved_bvn_data';

	static 'on_boarding_mode' = 'on_boarding_mode';

	static 'has_default_brm' = 'has_default_brm';
	static 'should_complete_self_onboarding_kyc' = 'SHOULD_COMPLETE_SELF_ONBOARDING_KYC';

	static 'digital_Onboarded' = 'digital_Onboarded';

	static 'business_address' = 'business_address';

	static 'USER_ROLE' = 'USER_ROLE';

	static 'on_boarding_form_data' = 'on_boarding_form_data';

	static 'phone_number_validation_key' = 'phone_number_validation_key';

	static 'current_on_boarding_step' = 'current_on_boarding_step';

	static current_soft_on_boarding_step = 'current_soft_on_boarding_step';

	static soft_onboarding_contact_data = 'soft_onboarding_contact_data';


	static 'current_kyc_lvl1_step' = 'current_kyc_lvl1_step';

	static 'current_kyc_lvl_2_step' = 'current_kyc_lvl_2_step';

	static 'current_kyc_lvl_3_step' = 'current_kyc_lvl_3_step';

	static 'current_kyc_lvl_4_step' = 'current_kyc_lvl_4_step';

	static 'kyc_lvl_form_data' = 'kyc_lvl_form_data';

	static residentAddressRejected = 'residentAddressRejected';

	static businessAddressRejected = 'residentAddressRejected';

	static kycAddressAccepted = 'kycAddressAccepted';

	static 'kyc_group_primer_route' = 'kyc_group_primer_route';

	static 'kyc_standing' = 'kyc_standing';

	static 'business_info_route' = 'business_info_route';

	static business_name_metamap_verification_redirect_route = 'business_name_metamap_verification_redirect_route';

	static 'allow_black_listed_name' = 'allow_black_listed_name';

	static 'black_listed_name' = 'black_listed_name';

	// tslint:disable-next-line:variable-name
	static is_categorized_business = 'is_categorized_business';

	// tslint:disable-next-line:variable-name
	static is_categorized_terminal = 'is_categorized_terminal';

	// tslint:disable-next-line:variable-name
	static business_category = 'business_category';
	// tslint:disable-next-line:variable-name
	static business_type = 'business_type';

	// tslint:disable-next-line:variable-name
	static feature_access = 'feature_access';

	// tslint:disable-next-line:variable-name
	static is_mobile_web_view_Logout = 'is_mobile_web_view_logout';

	static transaction_details = 'transaction_details';
	static businessNumber: 'business_number';

	// tslint:disable-next-line:variable-name
	static WCL_REQUEST_MODE = 'WCL_REQUEST_MODE';

	// tslint:disable-next-line:variable-name
	static loanRequestRef = 'loanRequestRef';
	// tslint:disable-next-line:variable-name
	static loanContractRef = 'loanContractRef';
	// tslint:disable-next-line:variable-name
	static wclContractManagementFee = 'wcl-contract-management-fee';
	// tslint:disable-next-line:variable-name
	static noBusinessType = 'noBusinessType';

	// tslint:disable-next-line:variable-name
	static BO_BUSINESS_TYPE_DETAILS = 'BO_BUSINESS_TYPE_DETAILS';
	static CURRENT_BO_BUSINESS_TYPE_DETAILS = 'CURRENT_BO_BUSINESS_TYPE_DETAILS';
	static UPDATED_BO_BUSINESS_TYPE_DETAILS = 'UPDATED_BO_BUSINESS_TYPE_DETAILS';
	static BUSINESS_CATEGORY_EDIT_MODE = 'BUSINESS_CATEGORY_EDIT_MODE';
	static BO_BUSINESS_TYPE_SUBMITTED = 'BO_BUSINESS_TYPE_SUBMITTED';

	// tslint:disable-next-line:variable-name
	static BO_RESIDENTIAL_ADDRESS_DETAILS = 'BO_RESIDENTIAL_ADDRESS_DETAILS';
	static CURRENT_BO_RESIDENTIAL_ADDRESS_DETAILS = 'CURRENT_BO_RESIDENTIAL_ADDRESS_DETAILS';
	static UPDATED_BO_RESIDENTIAL_ADDRESS_DETAILS = 'UPDATED_BO_RESIDENTIAL_ADDRESS_DETAILS';
	static RESIDENTIAL_ADDRESS_EDIT_MODE = 'RESIDENTIAL_ADDRESS_EDIT_MODE';
	static BO_RESIDENTIAL_ADDRESS_SUBMITTED = 'BO_RESIDENTIAL_ADDRESS_SUBMITTED';

	// tslint:disable-next-line:variable-name
	static BO_BUSINESS_ADDRESS_DETAILS = 'BO_BUSINESS_ADDRESS_DETAILS';
	static BUSINESS_ADDRESS_EDIT_MODE = 'BUSINESS_ADDRESS_EDIT_MODE';
	static BO_BUSINESS_ADDRESS_SUBMITTED = 'BO_BUSINESS_ADDRESS_SUBMITTED';
	static CURRENT_BO_BUSINESS_ADDRESS_DETAILS = 'CURRENT_BO_BUSINESS_ADDRESS_SUBMITTED';
	static UPDATED_BO_BUSINESS_ADDRESS_DETAILS = 'UPDATED_BO_BUSINESS_ADDRESS_DETAILS';

	// tslint:disable-next-line:variable-name
	static cacheBOPersonalDetails = 'cacheBOPersonalDetails';

	static WCL_LOAN_REQUEST_METAMAP_VERIFICATION_SUSPENSION = 'WCL_LOAN_REQUEST_METAMAP_VERIFICATION_SUSPENSION';
	static WCL_LOAN_REQUEST_METAMAP_VERIFICATION_SUSPENSION_DATE = 'WCL_LOAN_REQUEST_METAMAP_VERIFICATION_SUSPENSION_DATE';
	static WCL_LOAN_REQUEST_METAMAP_VERIFICATION_COUNT = 'WCL_LOAN_REQUEST_METAMAP_VERIFICATION_COUNT';
	static WCL_THRESHOLD_AMOUNT = 'WCL_THRESHOLD_AMOUNT';
	static WCL_PROVISIONAL_OFFER_INFO = 'WCL_PROVISIONAL_OFFER_INFO';

	// tslint:disable-next-line:variable-name
	static BO_PERSONAL_DETAILS = 'BO_PERSONAL_DETAILS';
	static CURRENT_BO_PERSONAL_DETAILS = 'CURRENT_BO_PERSONAL_DETAILS';
	static UPDATED_BO_PERSONAL_DETAILS = 'UPDATED_BO_PERSONAL_DETAILS';

	// tslint:disable-next-line:variable-name
	static WCL_SUSPENSION_REASON = 'WCL_SUSPENSION_REASON';

	static card_transaction_details = 'card_transaction_details';
	static card_transaction_dispute_details = 'card_transaction_dispute_details';
	static card_delivery_request_details = 'card_delivery_request_details';
	static terms_and_conditions_status = 'terms_and_conditions_status';
	static is_default_agency = 'is_default_agency';
	static kyc_level = 'kyc_level';
	static DESIGNATION = 'designation';
	static HAS_USER_PIN = 'hasUserPin';
	static PERFORM_FACE_MATCH_CHECK_ON_PASSWORD_CHANGE = 'performFaceMatchCheckOnPasswordChange'; // deprecated
	static PERFORM_FACE_MATCH_CHECK_ON_USER_PIN_RESET = 'performFaceMatchCheckOnUserPinReset'; // deprecated
	static TOTAL_BUSINESSES = 'businessCount';
	static card_push_remind_later = 'card_push_remind_later';
	static card_status = 'card_status';
	static card_visibility_in_my_state = 'card_visibility_in_my_state';
	static ACCOUNT_NO_SAVER = 'YBN_VEK_12345M';
	static BO_PRESENT_IN_BRM_ONBOARDING = 'BO_PRESENT_IN_BRM_ONBOARDING';
	static BRM_LIVELINESS_TYPE = 'BRM_LIVELINESS_TYPE';
	static BRM_BO_PRIMER = 'BRM_BO_PRIMER';
	static NIBSS_VERIFICATION_REDIRECT_URL = 'NIBSS_VERIFICATION_REDIRECT_URL';
	static NIBSS_VERIFICATION_COMPONENT_DATA = 'NIBSS_VERIFICATION_COMPONENT_DATA';
	static NIBSS_VERIFICATION_BVN_VALIDATION_KEY = 'NIBSS_VERIFICATION_BVN_VALIDATION_KEY';
	static NIBSS_VERIFICATION_IS_BRM_FLOW = 'NIBSS_VERIFICATION_IS_BRM_FLOW';
	static ACCOUNT_STATEMENT_DATA = 'ACCOUNT_STATEMENT_DATA';
	static ACCOUNT_STATEMENT_DATA_EMAIL = 'ACCOUNT_STATEMENT_DATA_EMAIL';
	static IS_BANK_BRM = 'IS_BANK_BRM';
	static BUSINESS_ACCOUNT_NUMBER = 'bus_account_num'
	static BUSINESS_ACCOUNT_ALIAS = 'bus_account_alias'
	static SAVED_NIN_DATA = 'SAVED_NIN_DATA'
	static STAFF_USER_BUSINESSES = 'STAFF_USER_BUSINESSES';
	static STAFF_USER_REFRESH_TOKEN = 'STAFF_USER_REFRESH_TOKEN';
	static STAFF_USER_REFRESH_TOKEN_EXPIRY = 'STAFF_USER_REFRESH_TOKEN_EXPIRY';
	static CLUSTER_MANAGER_REFRESH_TOKEN = 'CLUSTER_MANAGER_REFRESH_TOKEN';
	static PREVIOUS_PAGE_ROUTE = 'PREVIOUS_PAGE_ROUTE';
	static PREVIOUS_PAGE_DATA = 'PREVIOUS_PAGE_DATA';
	static DUPLICATE_PROFILE = 'DUPLICATE_PROFILE';
	static CAC_VERIFICATION_STATUS = 'CAC_VERIFICATION_STATUS'
	static SAVED_TOKEN_DATA = 'SAVED_TOKEN_DATA'
	static BUSINESS_OWNER_ID = 'BUSINESS_OWNER_ID';

	static GUARANTOR_ONE_EVENT_DATA = 'GUARANTOR_ONE_EVENT_DATA';
	static GUARANTOR_TWO_EVENT_DATA = 'GUARANTOR_TWO_EVENT_DATA';
	static LOAN_REQUEST_AMOUNT_EVENT_DATA = 'LOAN_REQUEST_AMOUNT_EVENT_DATA';
	static LOAN_REQUEST_BUSINESS_EMPLOYEE_EVENT_DATA = 'LOAN_REQUEST_BUSINESS_EMPLOYEE_EVENT_DATA';

	static LOAN_OFFER_INFO = 'LOAN_OFFER_INFO';

	static PROVISIONAL_OFFER_PRIMARY_BUSINESS_DATA = 'PROVISIONAL_OFFER_PRIMARY_BUSINESS_DATA';

	static PROVISIONAL_OFFER_LOAN_REQUEST_DETAILS = 'PROVISIONAL_OFFER_LOAN_REQUEST_DETAILS';

	static BUSINESS_DATA = 'business-data';

	static LOCATION_PERMISSION_RESPONSE = "location_permission_response";

	static SELECTED_CM_ROLE = 'selected_cm_role';

	static PROVISIONAL_OFFER_LOAN_OFFER_DETAILS = 'PROVISIONAL_OFFER_LOAN_OFFER_DETAILS';

	static SHOULD_PRESERVE_SCUML_FILES = 'SHOULD_PRESERVE_SCUML_FILES';

	static SHOW_BRM_RECATEGORIZATION_NOTIFICATION = 'showBrmRecategorizationNotification';

	static BUSINESS_OWNER_DETAILS = 'BUSINESS_OWNER_DETAILS';

	static SELECTED_LOAN_PRODUCT = 'SELECTED_LOAN_PRODUCT';

	static BUSINESS_POS_TERMINAL = 'business_pos_terminal';

  static ONGOING_LOAN_DATA = 'ongoing_loan_data';

	static SALES_PARTNER_CODE = 'SALES_PARTNER_CODE';
	
	static PARTNER_MFE_UPGRADE = 'PARTNER_MFE_UPGRADE'

}
